module.exports = __webpack_public_path__ + "img/ico-call.47bd70b9.gif";